<template>
  <el-dialog
    :close-on-click-modal="false"
    title="导航地图"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    top="30px"
    :width="`${dialogWidth || 800}px`"
  >
    <section v-loading="getDetailLoading">
      <baidu-map :scroll-wheel-zoom="true">
        <bm-view
          :style="`width: 100%; height: ${mapHeight || 500}px;`"
        ></bm-view>
        <bm-driving
          :start="originData.start"
          :end="originData.end"
          :waypoints="originData.waypoints"
          :panel="false"
          :auto-viewport="true"
          :selectFirstResult="true"
        ></bm-driving>

        <my-overlay
          v-for="(item, index) in originData.allPoints"
          :key="index"
          :position="{ lng: item.lng, lat: item.lat }"
          :active="true"
        >
          <div slot="text">
            <p>{{ item.address }}</p>
          </div>
        </my-overlay>
      </baidu-map>
    </section>
    <section slot="footer" class="dialog-footer">
      <!-- <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
        >关 闭</el-button
      > -->
    </section>
  </el-dialog>
</template>

<script>
import MyOverlay from './myOverlay.vue';
export default {
  components: {
    MyOverlay,
  },
  computed: {
    dialogWidth () {
      return document.documentElement.clientWidth * 0.96;
    },
    mapHeight () {
      return document.documentElement.clientHeight * 0.8;
    },
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      originData: {},
      active: false,
    };
  },
  methods: {

    show (item) {
      this.dialogFormVisible = true;
      // 途经点，用于地图组件
      const waypoints = [];
      // 所有点，用于地图白色框框展示（my-overlay）
      const allPoints = [];
      // 起点
      item.start = {
        lng: Number(item.sourceAddressNavigationLng),
        lat: Number(item.sourceAddressNavigationLat),
        address: '起点：' + item.sourceAdderssDtl,
      };
      allPoints.push(item.start);
      for (let i = 0; i < item.computeBeanList.length; i++) {
        allPoints.push({
          lng: Number(item.computeBeanList[i].desAddressNavigationLng),
          lat: Number(item.computeBeanList[i].desAddressNavigationLat),
          address: `卸货点${i + 1}：` + item.computeBeanList[i].desAdderssDtl,
        });
        if (i === item.computeBeanList.length - 1) {
          // 最后一个点作为终点
          item.end = {
            lng: Number(item.computeBeanList[i].desAddressNavigationLng),
            lat: Number(item.computeBeanList[i].desAddressNavigationLat),
            address: item.computeBeanList[i].desAdderssDtl,
          };
        } else {
          // 其他点作为途经点
          waypoints.push({
            lng: Number(item.computeBeanList[i].desAddressNavigationLng),
            lat: Number(item.computeBeanList[i].desAddressNavigationLat),
            address: item.computeBeanList[i].desAdderssDtl,
          });
        }
      }
      item.waypoints = waypoints;
      item.allPoints = allPoints;
      this.originData = item;
    },

    customFormPost () {
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
